export default __webpack_public_path__ + "static/media/my-orders.87f483e0.svg";